<div class="color">
    <div class="container">
        <div class="text">
            <h1>Contact us</h1>
            <div class="contactRow">
                <img
                    class="icon"
                    src="https://icongr.am/material/map-search.svg?size=36&color=ffae00"
                    alt="icon"
                />
                <p>Strandveien 8, 8145 Storvik, Norway</p>
            </div>
            <div class="contactRow">
                <img
                    class="icon"
                    src="https://icongr.am/material/phone.svg?size=36&color=ffae00"
                    alt="icon"
                />
                <p>(+47)957 43 397</p>
            </div>
            <div class="contactRow">
                <img
                    class="icon"
                    src="https://icongr.am/material/mail.svg?size=36&color=ffae00"
                    alt="icon"
                />
                <p>info@swlean.com</p>
            </div>

            <p>
                <strong>GET IN TOUCH</strong><br />We sincerly would like you to
                contact us if you want to work with us in a project or want to
                hear more about what we offer as a company.
            </p>
        </div>
    </div>
</div>

<style>
    .contactRow {
        display: flex;
        align-items: start;
        gap: 10px;
        padding-bottom: 10px;
    }
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 100px;
        padding-bottom: 300px;
        max-width: 400px;
    }
    .color {
        background-color: white;
    }
    h1 {
        font-size: 2em;
    }
</style>
